<div class="my-4">
  <!-- <p-calendar appendTo="body" [formControl]="control" [placeholder]="label | translate" [timeOnly]="true"></p-calendar> -->
  <p-calendar appendTo="body" [ngModel]="value" [placeholder]="label | translate" [timeOnly]="true" (ngModelChange)="onValueChange($event)"></p-calendar>
</div>
